module.exports = __webpack_public_path__ + "static/media/logo.cd34b865.png";